import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import { NavLink, NavLinkMode } from '@rd/types';

@Component({
  selector: 'rd-core-side-nav-link',
  templateUrl: './side-nav-link.component.html',
  styleUrls: ['./side-nav-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SideNavLinkComponent {
  @HostBinding('class.rd-core-side-nav-link') componentClass = true;
  @Input() navLink: NavLink;
  @Output() clickEvent: EventEmitter<void> = new EventEmitter<void>();

  constructor() {}

  navLinkMode(): NavLinkMode {
    if (!this.redirectURLExists()) {
      return 'callback';
    }

    if (this.isInternalURL()) {
      return 'internalURL';
    } else {
      return 'externalURL';
    }
  }

  navLinkClicked(): void {
    this.clickEvent.emit();
  }

  private redirectURLExists(): boolean {
    return this.navLink.route !== null;
  }

  private isInternalURL(): boolean {
    const { route } = this.navLink;
    return !(
      route.toString().startsWith('http://') ||
      route.toString().startsWith('https://')
    );
  }
}
